// src/pages/countries/CreateCountries.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCountries from "../../components/countries/FormAddEditCountries";

const CreateCountries = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/countries");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCountries
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateCountries;
